import React from 'react';
import MedicationProfileTitle from '../../MedicationProfileTitle';
import { PlusCircle } from 'react-bootstrap-icons';
import { Collapse } from 'react-bootstrap';
import Divider from '../../../../../components/Divider/Divider';
import AppointmentItem from './AppointmentItem';
import AddAppointmentForm from './AddAppointmentForm';
import moment from 'moment';

const Appointments = ({
  canEdit,
  appointments,
  onAddAppointment,
  onDeleteAppointment,
  onEditAppointment,
}) => {
  const [openAddAppointment, setOpenAddAppointment] = React.useState(false);

  const onSaveAddAppointment = (values) => {
    const formatValues = {
      apptType: values.apptType || '',
      apptTime: values.apptTime
        ? moment(values.apptTime).format('hh:mm A')
        : '',
      apptDate: values.apptDate
        ? moment(values.apptDate).format('YYYY-MM-DD')
        : '',
    };
    onAddAppointment(formatValues);
    onCloseAddAppointment();
  };

  const onEditAppointmentChange = (values, index) => {
    const formatValues = {
      apptType: values.apptType || '',
      apptTime: values.apptTime
        ? moment(values.apptTime).format('hh:mm A')
        : '',
      apptDate: values.apptDate
        ? moment(values.apptDate).format('YYYY-MM-DD')
        : '',
    };
    onEditAppointment(formatValues, index);
    onCloseAddAppointment();
  };

  const onCloseAddAppointment = () => setOpenAddAppointment(false);
  return (
    <div>
      <MedicationProfileTitle
        actions={
          canEdit
            ? [
                {
                  name: 'Add appointment',
                  icon: <PlusCircle />,
                  onClickAction: () => setOpenAddAppointment(true),
                  variant: 'btnPrimary',
                },
              ]
            : []
        }
        title="Follow up appointments"
        titleClassName="medication-profile-font-gray fw-semibold"
      />

      {canEdit && (
        <AddAppointmentForm
          open={openAddAppointment}
          onClose={onCloseAddAppointment}
          onSave={onSaveAddAppointment}
        />
      )}
      <Divider />
      {appointments.map((appointment, index) => (
        <AppointmentItem
          key={appointment.appDate + '' + index}
          appointment={appointment}
          canEdit={canEdit}
          onDelete={() => onDeleteAppointment(index)}
          onEditAppointment={(values) => onEditAppointmentChange(values, index)}
        />
      ))}
      <Divider />
    </div>
  );
};

export default Appointments;
